import type { ENV } from "../config/loadShellEnv";
import { MFE_OVERRIDE_KEY, MFE_VARIANT_OVERRIDE_KEY } from "./mfeConfig";

const storeOverridesFromHash = () => {
  const params = new URLSearchParams(location.hash.slice(1));
  const overrides = params.getAll(MFE_OVERRIDE_KEY);

  if (overrides.length) {
    overrides.length &&
      sessionStorage.setItem(MFE_OVERRIDE_KEY, JSON.stringify(overrides));
    params.delete(MFE_OVERRIDE_KEY);
    const newHash = params.toString();
    const formattedHash = newHash ? "#" + newHash : "";
    const newLocation = location.pathname + location.search + formattedHash;
    history.replaceState(history.state, "", newLocation);
  }
  if (sessionStorage.getItem(MFE_OVERRIDE_KEY))
    document.body.classList.add("override-indicator");
};

const handleVariantHashParam = () => {
  const params = new URLSearchParams(location.hash.slice(1));
  const variantOverride = params.getAll(MFE_VARIANT_OVERRIDE_KEY);

  if (variantOverride.length) {
    variantOverride.length &&
      sessionStorage.setItem(
        MFE_VARIANT_OVERRIDE_KEY,
        JSON.stringify(variantOverride)
      );
    params.delete(MFE_VARIANT_OVERRIDE_KEY);
    const newHash = params.toString();
    const formattedHash = newHash ? "#" + newHash : "";
    const newLocation = location.pathname + location.search + formattedHash;
    history.replaceState(history.state, "", newLocation);
  }
  if (sessionStorage.getItem(MFE_VARIANT_OVERRIDE_KEY))
    document.body.classList.add("override-indicator");
};

export const setupMFELoaders = (env: typeof ENV) => {
  handleVariantHashParam();
  if (env !== "prod") {
    storeOverridesFromHash();
  }
};
